import { render, staticRenderFns } from "./PopupRiskInfoEp3_3x3.vue?vue&type=template&id=8b22af7e&scoped=true"
import script from "./PopupRiskInfoEp3_3x3.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfoEp3_3x3.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfoEp3_3x3.vue?vue&type=style&index=0&id=8b22af7e&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfoEp3_3x3.vue?vue&type=style&index=1&id=8b22af7e&prod&lang=css"
import style2 from "./PopupRiskInfoEp3_3x3.vue?vue&type=style&index=2&id=8b22af7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b22af7e",
  null
  
)

export default component.exports